import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchAllCourses,
  fetchCourseById,
  createCourse,
  updateCourse,
  deleteCourse,
  addCourseMembers,
  updateUserCourse,
  getKeynotes,
} from '../services/courseService';

export const useCourses = (userId) => {
  const queryClient = useQueryClient();

  const getAllCourses = useQuery({
    queryKey: ['courses', userId],
    queryFn: () => fetchAllCourses(userId),
    enabled: !!userId,
  });

  const createCourses = useMutation({
    mutationFn: createCourse,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    },
  });

  const updateCourses = useMutation({
    mutationFn: ({ id, updatedData }) => updateCourse(id, updatedData),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['courses'] });
      queryClient.invalidateQueries({ queryKey: ['course', variables.id] });
    },
  });

  const deleteCourses = useMutation({
    mutationFn: ({ userId, courseId }) => deleteCourse(userId, courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    },
  });

  return { getAllCourses, createCourses, updateCourses, deleteCourses };
};

export const useCourseById = (courseId) => {
  return useQuery({
    queryKey: ['course', courseId],
    queryFn: () => fetchCourseById(courseId),
    enabled: !!courseId,
  });
};

export const useUpdateCourseView = () => {
  const queryClient = useQueryClient();

  const addMembers = useMutation({
    mutationFn: ({ courseId, userId }) => addCourseMembers(courseId, userId),
  });

  const updateUser = useMutation({
    mutationFn: ({ userId, courseId }) => updateUserCourse(userId, courseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    },
  });

  return { addMembers, updateUser };
};

export const useGetKeynotes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ courseId, title, language }) => getKeynotes(courseId, title, language),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['course', variables.courseId] });
    },
  });
};
